<script setup>
import { computed } from "vue";
import { NavigationMenuTrigger, useForwardProps } from "radix-vue";
import { navigationMenuTriggerStyle } from "../navigation-menu/index.js";
import { cn } from "../../../lib/utils";
import { Icon } from "@iconify/vue";

const props = defineProps({
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <NavigationMenuTrigger
    v-bind="forwardedProps"
    :class="cn(navigationMenuTriggerStyle(), 'group', props.class)"
  >
    <slot />
    <Icon
      height="16"
      icon="solar:alt-arrow-down-linear"
      class="text-text-content"
    />
  </NavigationMenuTrigger>
</template>
